import React from "react";
import { Card } from "primereact/card";
import { Link, useLocation } from "react-router-dom";
import PermissionGate from "~/components/PermissionGate";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";

const SettingsSidebar = () => {
  const location = useLocation();
  const activeTab = location.pathname.split("/")[2] || "general-information";
  const { value: isTenantFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.TENANT,
    false,
  );

  return (
    <>
      <Card className="card-style p-0">
        <div className="flex flex-column">
          <Link
            to="/settings/my-profile"
            className={`sidebar-align ${activeTab === "my-profile" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-id-card icon-color" />
              <p className="sidebar-menu">My Account</p>
            </div>
            <span className="pi pi-angle-right icon-color" />
          </Link>
          {/* <Link
            to="/settings/notification"
            className={`sidebar-align ${activeTab === "notification" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <span className="pi pi-bell icon-color"></span>
              <p className="sidebar-menu">Notification</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link> */}
          {!isTenantFeatureEnabled && (
            <PermissionGate resource="usermanagement" action="view">
              <Link
                to="/settings/users"
                className={`sidebar-align ${activeTab === "users" ? "active-entity" : "menu-hover"}`}
              >
                <div className="flex align-items-center">
                  <span className="pi pi-users icon-color" />
                  <p className="sidebar-menu">Users</p>
                </div>
                <span className="pi pi-angle-right icon-color" />
              </Link>
            </PermissionGate>
          )}
          <PermissionGate resource="events" action="create">
            <Link
              to="/settings/import-payslip-events"
              className={`sidebar-align ${activeTab === "import-payslip-events" ? "active-entity" : "menu-hover"}`}
            >
              <div className="flex align-items-center">
                <span className="pi pi-upload icon-color" />
                <p className="sidebar-menu">Import Payslip Events</p>
              </div>
              <span className="pi pi-angle-right icon-color" />
            </Link>
          </PermissionGate>
        </div>
      </Card>
    </>
  );
};

export default SettingsSidebar;
